import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { startBikefit } from '../../../../components/Bikefit/lib/bikefit';
import { useTranslation } from 'react-i18next';
import ReactGA from "react-ga4";
import {trackBikefitCTA} from "../../../../lib/mixpanelClient";

const BikeFittingButton = ({ buttonColor, textColor, className, text, isHero }) => {
  const { t } = useTranslation()
  const [bg] = useState(buttonColor);
  const [color] = useState(textColor);

  const bikefitClicked = () => {
    ReactGA.event({
      action: 'click',
      category: 'bikefit_home_start',
      label: `Start bikefit from the home page`,
      value: 0
    });

    trackBikefitCTA('bikefitting');

    startBikefit();
  }

  return (
    <Button
      variant=''
      style={{ backgroundColor: bg, color: color }}
      className={`custom-button cta ${className}`}
      onClick={bikefitClicked}
    >
      {t(text ? text : "bikeFittingBtn")}
    </Button>
  );
};

export default BikeFittingButton;